window.DADID_Cookie = {
    getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        return parts.length === 2 ? parts.pop().split(';').shift() : null;
    },

    setCookie(name, value) {
        document.cookie = `${name}=${value}; path=/`;
    }
};

class AnaphylaxisQuiz {
    constructor() {
        this.wrapper = document.querySelector('.digital-anaphylaxis-discussion-quiz-wrapper');
        if (!this.wrapper) return;
        this.quizWrapper = this.wrapper.querySelector('.quiz-wrapper');
        this.submitCardWrapper = this.wrapper.querySelector('.quiz-submit-card');
        this.signupForm = this.wrapper.querySelector('.quiz-submit-card form');
        this.startWrapper = this.wrapper.querySelector('.quiz-start-wrapper');
        this.consentCheckbox = this.wrapper.querySelector('.consent-checkbox-wrapper .custom-checkbox');
        this.currentQuestion = 0;
        this.answers = [];
        this.qaPairs = [];
        this.questions = [
            {
                id: 1,
                title: 'Any changes in your child’s health?',
                description: 'Updates since the previous appointment',
                placeholder: 'e.g. I think my child may be reacting to a new allergy trigger.',
                type: 'comment'
            },
            {
                id: 2,
                title: 'Any severe allergic reactions?',
                description: 'Updates since the previous appointment',
                placeholder: 'e.g. My child had a severe allergic reaction after eating cookies',
                type: 'comment'
            },
            {
                id: 3,
                title: 'Do you know your child’s triggers?',
                description: 'How things are going right now',
                type: 'trigger'
            },
            {
                id: 4,
                title: 'Do you and your child know how to avoid relevant triggers?',
                description: 'How things are going right now',
                type: 'auto'
            },
            {
                id: 5,
                title: 'If your child has a severe allergic reaction, do you both know what to do?',
                description: 'How things are going right now',
                type: 'auto'
            },
            {
                id: 6,
                title: 'Are you or your child worried about dealing with a severe allergic reaction?',
                description: 'How things are going right now',
                placeholder: 'Tell us what worries you',
                type: 'comment'
            },
            {
                id: 7,
                title: 'Are you and your child confident using the emergency medication, knowing when and how to use it?',
                description: 'How things are going right now',
                type: 'auto'
            },
            {
                id: 8,
                title: 'Would you like more information on any specific topics?',
                description: 'How things are going right now',
                placeholder: 'e.g. adrenaline in emergencies, school, eating out, travel',
                type: 'comment'
            },
            {
                id: 9,
                title: 'Do you have any questions about a new or existing allergy?',
                description: 'How things are going right now',
                placeholder: 'e.g. Should we review my child’s emergency adrenaline?',
                type: 'comment'
            },
            {
                id: 'final_comment',
                title: 'Last one! Setting goals for the appointment',
                description: 'Think about what matters most to you and your child about living with a severe allergy and how the doctor can help',
                type: 'final-comment'
            }
        ];
        this.newsletterSignupWrapper = this.wrapper.querySelector('.quiz-submit-card .newsletter_signup_checkbox');
        this.newsletterSignupCheckbox = this.wrapper.querySelector('.quiz-submit-card .newsletter_signup_checkbox .custom-checkbox');
        this.knownUser = false;
        this.newsletterSignupVal = 'off';
        this.DADID_Cookie = null;
        this.newsletter_Cookie = null;
        this.DAD_email = null;
        this.cookieHelper = window.DADID_Cookie;
        this.init();
    }

    init() {
        this.startEvents();

        const dadCookie = this.cookieHelper.getCookie('DADID_Cookie');

        if (dadCookie && dadCookie !== 'DADID_Cookie') {
            this.DADID_Cookie = dadCookie;
        } else {
            this.DADID_Cookie = localStorage.getItem('DADID_Cookie');
        }

        this.newsletter_Cookie = localStorage.getItem('newsletter_signup');

        if (this.DADID_Cookie != null && this.newsletter_Cookie === 'on') {
            this.knownUser = true;
            this.newsletterSignupWrapper.classList.add('d-none');
        } else {
            this.knownUser = false;
        }
    }

    startEvents() {
        this.wrapper.querySelector('.quiz-btn').addEventListener('click', (e) => {
            e.preventDefault();
            this.wrapper.classList.add('active');

            if (this.wrapper.querySelector('.quiz-heading').classList.contains('thanks-active')) {
                this.wrapper.querySelector('.quiz-heading').classList.remove('thanks-active');
            }

            this.wrapper.querySelector('.quiz-btn-description-wrapper').classList.add('d-none');
            this.startWrapper.classList.remove('d-none');
        });

        this.wrapper.querySelector('.quiz-start-btn').addEventListener('click', () => {
            if (!this.consentCheckbox.checked) {

                const label = this.wrapper.querySelector('.quiz-input-label-wrapper');
                label.classList.add('required');
                if (window.innerWidth < 768) {
                    requestAnimationFrame(() => {
                        this.wrapper.querySelector('.quiz-input-label-wrapper').scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        });
                    });
                }

                setTimeout(() => {
                    label.classList.remove('required');
                }, 2000);

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'dad_started_consent_no',
                    property:'caregiver'
                });

                return;
            }
            this.startQuiz();

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'dad_started',
                property:'caregiver'
            });
        });

        this.wrapper.querySelector('.quiz-close-btn').addEventListener('click', () => {
            this.resetQuiz();
        });
    }

    startQuiz() {
        this.startWrapper.classList.add('d-none');
        this.wrapper.querySelector('.quiz-heading').classList.add('d-none');
        this.wrapper.querySelector('.quiz-close-btn').classList.remove('d-none');
        this.quizWrapper.classList.remove('d-none');
        this.renderQuestion();
    }

    renderQuestion() {
        const question = this.questions[this.currentQuestion];
        if (!question) {
            this.renderSubmitScreen();
            return;
        }

        if (this.currentQuestion >= 2) {
            this.wrapper.classList.add('active-dark-bg');
        } else {
            this.wrapper.classList.remove('active-dark-bg');
        }

        const savedAnswer = this.answers.find(
            item => item.question_id === question.id
        );

        const isFinalComment = question.type === 'final-comment';

        this.quizWrapper.innerHTML = `
            <div class="quiz-question-card card-${question.id} ${isFinalComment ? 'final-comment-card' : ''}">
                ${!isFinalComment ? `
        
                    <div class="question-number">
                        ${question.id}
                    </div>
                    
                    <div class="question-description-text">
                        ${question.description}
                    </div>
                    
                    ${this.renderPagination()}
                    
                ` : ''}
                
                ${isFinalComment ? `
                    <div class="last-question-text">
                        LAST one!
                    </div>
                ` : ''}

                <h3 class="question-title">
                    ${question.title}
                </h3>
                
                ${isFinalComment ? `
                    <div class="final-description">
                        ${question.description}
                    </div>
                ` : ''}

                ${this.renderQuestionContent(question)}

                <div class="quiz-navigation">
                    ${this.currentQuestion > 0 ? `
                        <button class="quiz-back-btn">
                          <svg width="35" height="32" viewBox="0 0 35 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.6811 0.75L0.75 15.8573L15.6811 30.9699" stroke="#002559" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M33.75 15.75H0.75" stroke="#002559" stroke-width="1.5" stroke-linecap="round"/>
                          </svg>
                          Back
                        </button>
                    ` : ''}
                </div>
            </div>
        `;

        this.bindQuestionEvents(question);

        this.restoreAnswer(question, savedAnswer);

        requestAnimationFrame(() => {
            this.wrapper.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        });
    }

    renderPagination() {
        return `
            <div class="pagination">
                ${this.questions
            .filter(item => item.id !== 'final_comment')
            .map((_, index) => `
                        <div class="step ${index === this.currentQuestion ? 'active' : ''}"></div>
                    `).join('')}
            </div>
        `;
    }

    renderQuestionContent(question) {
        switch (question.type) {

            case 'comment':
                return `
                    <div class="quiz-answer-btn-wrapper">
                        <button class="quiz-answer-btn" data-answer="YES">
                            Yes
                        </button>
                        <button class="quiz-answer-btn" data-answer="NO">
                            No
                        </button>
                    </div>

                    <div class="quiz-comment-wrapper d-none">
                        <div class="quiz-comment-field position-relative">
                            <textarea class="quiz-comment-input" placeholder="${question.placeholder}" maxlength="200"></textarea>
                            <div class="quiz-comment-count">0/200</div>
                        </div>
                    </div>
                    
                    <button class="quiz-next-btn d-none">
                        Next
                        <svg width="35" height="32" viewBox="0 0 35 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.8189 0.75L33.75 15.8573L18.8189 30.9699" stroke="#002559" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M0.75 15.75H33.75" stroke="#002559" stroke-width="1.5" stroke-linecap="round"/>
                        </svg>
                    </button> 
                `;

            case 'trigger':
                return `
                    <div class="quiz-answer-btn-wrapper">
                        <button class="quiz-answer-btn" data-answer="YES">
                            Yes
                        </button>

                        <button class="quiz-answer-btn" data-answer="NO">
                            No
                        </button>
                    </div>

                    <div class="quiz-trigger-wrapper d-none">
                        <label>
                            <input type="checkbox" value="Food">
                            <span class="custom-checkbox"></span>
                            Food
                        </label>

                        <label>
                            <input type="checkbox" value="Insect venom">
                            <span class="custom-checkbox"></span>
                            Insect venom
                        </label>

                        <label>
                            <input type="checkbox" value="Medication">
                            <span class="custom-checkbox"></span>
                            Medication
                        </label>
                        
                         <label>
                            <input type="checkbox" value="Latex">
                            <span class="custom-checkbox"></span>
                            Latex
                        </label>
                        
                         <label>
                            <input type="checkbox" value="Other">
                            <span class="custom-checkbox"></span>
                            Other
                        </label>
                    </div>
                    
                    <button class="quiz-trigger-next-btn d-none">
                        Next
                        <svg width="35" height="32" viewBox="0 0 35 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.8189 0.75L33.75 15.8573L18.8189 30.9699" stroke="#002559" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M0.75 15.75H33.75" stroke="#002559" stroke-width="1.5" stroke-linecap="round"/>
                        </svg>
                    </button>
                `;

            case 'auto':
                return `
                    <div class="quiz-answer-btn-wrapper">
                        <button class="quiz-answer-btn auto-btn" data-answer="YES">
                            Yes
                        </button>

                        <button class="quiz-answer-btn auto-btn" data-answer="NO">
                            No
                        </button>
                    </div>
                    
                    <button class="quiz-next-btn d-none">
                        Next
                        <svg width="35" height="32" viewBox="0 0 35 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.8189 0.75L33.75 15.8573L18.8189 30.9699" stroke="#002559" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M0.75 15.75H33.75" stroke="#002559" stroke-width="1.5" stroke-linecap="round"/>
                        </svg>
                    </button>
                `;

            case 'final-comment':
                return `
                    <div class="quiz-comment-wrapper">
                        <div class="quiz-comment-field position-relative">
                            <textarea class="quiz-comment-input" placeholder="e.g. Hidden allergens in food, Travel certificate, Taking emergency medication on a flight, Managing anaphylaxis risk at nursery/school, Treatment options, Emergency medication and storage" maxlength="200"></textarea>
                            <div class="quiz-comment-count">0/200</div>
                        </div>
                        <button class="quiz-submit-final-btn">
                            Next
                            <svg width="35" height="32" viewBox="0 0 35 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18.8189 0.75L33.75 15.8573L18.8189 30.9699" stroke="#002559" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M0.75 15.75H33.75" stroke="#002559" stroke-width="1.5" stroke-linecap="round"/>
                            </svg>
                        </button>
                    </div>
                `;

            default:
                return '';
        }
    }

    bindQuestionEvents(question) {
        const card = this.quizWrapper.querySelector('.quiz-question-card');

        const backBtn = card.querySelector('.quiz-back-btn');
        if (backBtn) {
            backBtn.addEventListener('click', () => {
                this.prevQuestion();
            });
        }

        card.addEventListener('click', (e) => {
            const target = e.target.closest('button');
            if (!target) return;

            const goToNextQuestion = (data, delay = 0) => {
                this.saveAnswer(data);
                setTimeout(() => {
                    this.nextQuestion();
                }, delay);
            };

            const setActiveButton = () => {
                card.querySelectorAll('.quiz-answer-btn').forEach(btn => {
                    btn.classList.remove('active');
                });

                target.classList.add('active');
            };

            if (question.type === 'comment') {

                if (target.dataset.answer) {
                    setActiveButton();
                    const answer = target.dataset.answer;

                    if (answer === 'YES') {
                        card.querySelector('.quiz-comment-wrapper')?.classList.remove('d-none');
                        card.querySelector('.quiz-next-btn')?.classList.remove('d-none');
                        requestAnimationFrame(() => {
                            card.querySelector('.quiz-comment-wrapper').scrollIntoView({
                                behavior: 'smooth',
                                block: 'start'
                            });
                        });
                    }

                    if (answer === 'NO') {
                        card.querySelector('.quiz-comment-wrapper')?.classList.add('d-none');
                        goToNextQuestion({
                            question_id: question.id,
                            question: question.title,
                            answer: 'NO',
                            comment: ''
                        }, 500);
                    }
                    return;
                }

                if (target.classList.contains('quiz-next-btn')) {
                    const activeBtn = card.querySelector('.quiz-answer-btn.active');
                    if (!activeBtn) return;

                    const comment = card.querySelector('.quiz-comment-input')?.value || '';
                    goToNextQuestion({
                        question_id: question.id,
                        question: question.title,
                        answer: activeBtn.dataset.answer,
                        comment
                    });

                    return;
                }
            }

            if (question.type === 'trigger') {

                if (target.dataset.answer) {
                    setActiveButton();
                    const answer = target.dataset.answer;

                    if (answer === 'YES') {
                        card.querySelector('.quiz-trigger-wrapper')?.classList.remove('d-none');
                        card.querySelector('.quiz-trigger-next-btn')?.classList.remove('d-none');
                        requestAnimationFrame(() => {
                            card.querySelector('.quiz-trigger-wrapper').scrollIntoView({
                                behavior: 'smooth',
                                block: 'start'
                            });
                        });
                    }

                    if (answer === 'NO') {
                        card.querySelector('.quiz-trigger-wrapper')?.classList.add('d-none');

                        goToNextQuestion({
                            question_id: question.id,
                            question: question.title,
                            answer: 'NO',
                            triggers: []
                        }, 500);
                    }
                    return;
                }

                if (target.classList.contains('quiz-trigger-next-btn')) {
                    const activeBtn = card.querySelector('.quiz-answer-btn.active');
                    if (!activeBtn) return;

                    let triggers = [];

                    if (activeBtn.dataset.answer === 'YES') {
                        triggers = [
                            ...card.querySelectorAll('input:checked')
                        ].map(input => input.value);

                        if (triggers.length === 0) {
                            card.querySelector('.quiz-trigger-wrapper')?.classList.add('required');

                            setTimeout(() => {
                                card.querySelector('.quiz-trigger-wrapper')?.classList.remove('required');
                            }, 2000);
                            return;
                        }
                    }

                    this.saveAnswer({
                        question_id: question.id,
                        question: question.title,
                        answer: activeBtn.dataset.answer,
                        triggers
                    });
                    this.nextQuestion();
                    return;
                }
            }

            if (question.type === 'auto') {
                const existingAnswer = this.answers.find(
                    item => item.question_id === question.id
                );

                if (target.dataset.answer) {
                    setActiveButton();
                    const activeBtn = card.querySelector('.quiz-answer-btn.active');
                    if (!activeBtn) return;
                    const data = {
                        question_id: question.id,
                        question: question.title,
                        answer: activeBtn.dataset.answer,
                    };

                    if (existingAnswer) {
                        this.saveAnswer(data);
                        card.querySelector('.quiz-next-btn')?.classList.remove('d-none');
                        return;
                    }

                    goToNextQuestion(data, 500);
                    return;
                }

                if (target.classList.contains('quiz-next-btn')) {
                    const activeBtn = card.querySelector('.quiz-answer-btn.active');
                    if (!activeBtn) return;
                    goToNextQuestion({
                        question_id: question.id,
                        question: question.title,
                        answer: activeBtn.dataset.answer,
                    });
                    return;
                }
            }

            if (question.type === 'final-comment') {
                if (target.classList.contains('quiz-submit-final-btn')) {
                    const comment = card.querySelector('.quiz-comment-input')?.value || '';

                    goToNextQuestion({
                        question_id: question.id,
                        question: question.title,
                        comment
                    });

                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: 'dad_completed',
                        property:'caregiver'
                    });
                }
            }
        });

        const textarea = card.querySelector('.quiz-comment-input');
        const counter = card.querySelector('.quiz-comment-count');

        if (textarea && counter) {
            counter.innerText = `${textarea.value.length}/200`;
            textarea.addEventListener('input', () => {
                counter.innerText = `${textarea.value.length}/200`;
            });
        }
    }

    saveAnswer(data) {
        const existingIndex = this.answers.findIndex(
            item => item.question_id === data.question_id
        );

        if (existingIndex !== -1) {
            this.answers[existingIndex] = data;
        } else {
            this.answers.push(data);
        }
    }

    QuestionDataLayer () {
        const item = this.answers.find(
            data => data.question_id === this.currentQuestion
        );

        if (!item) return;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'dad_question_answer',
            questionNumber: String(item.question_id),
            answerValue: item.comment || (item.triggers?.length ? item.triggers : null) || item.answer,
            property:'caregiver'
        });
    }

    nextQuestion() {
        this.currentQuestion++;
        this.renderQuestion();
        this.QuestionDataLayer ();
    }

    prevQuestion() {
        if (this.currentQuestion === 0) return;
        this.QuestionDataLayer ();
        this.currentQuestion--;
        this.renderQuestion();
    }

    restoreAnswer(question, savedAnswer) {
        if (!savedAnswer) return;

        const card = this.quizWrapper.querySelector('.quiz-question-card');

        if (savedAnswer.answer) {
            const activeBtn = card.querySelector(
                `.quiz-answer-btn[data-answer="${savedAnswer.answer}"]`
            );
            if (activeBtn) {
                activeBtn.classList.add('active');
            }
        }

        if (question.type === 'comment') {
            const nextBtn = card.querySelector('.quiz-next-btn');
            if (savedAnswer.answer === 'YES') {
                card.querySelector('.quiz-comment-wrapper')?.classList.remove('d-none');
                if (nextBtn) {
                    nextBtn.classList.remove('d-none');
                }
            }

            if (savedAnswer.answer === 'NO') {
                if (nextBtn) {
                    nextBtn.classList.remove('d-none');
                }
            }

            const textarea = card.querySelector('.quiz-comment-input');
            if (textarea) {
                textarea.value = savedAnswer.comment || '';
            }
        }

        if (question.type === 'trigger') {
            const nextBtn = card.querySelector('.quiz-trigger-next-btn');
            if (savedAnswer.answer === 'YES') {
                card.querySelector('.quiz-trigger-wrapper')?.classList.remove('d-none');
                if (nextBtn) {
                    nextBtn.classList.remove('d-none');
                }

                if (savedAnswer.triggers?.length) {
                    savedAnswer.triggers.forEach(trigger => {
                        const checkbox = [
                            ...card.querySelectorAll('input[type="checkbox"]')
                        ].find(input => input.value === trigger);
                        if (checkbox) {
                            checkbox.checked = true;
                        }
                    });
                }
            }

            if (savedAnswer.answer === 'NO') {
                if (nextBtn) {
                    nextBtn.classList.remove('d-none');
                }
            }
        }

        if (question.type === 'auto') {
            const nextBtn = card.querySelector('.quiz-next-btn');
            if (nextBtn) {
                nextBtn.classList.remove('d-none');
            }
        }

        if (question.type === 'final-comment') {
            const textarea = card.querySelector('.quiz-comment-input');
            if (textarea) {
                textarea.value = savedAnswer.comment || '';
            }
        }
    }

    renderSubmitScreen() {

        this.wrapper.classList.remove('active-dark-bg');
        this.submitCardWrapper.classList.remove('d-none');
        this.quizWrapper.classList.add('d-none');

        console.log(this.answers)

        const submitBtn = this.submitCardWrapper.querySelector('.quiz-submit-btn');

        submitBtn.onclick = async () => {

            const name = this.submitCardWrapper.querySelector('.quiz-name-input').value;
            const email = this.submitCardWrapper.querySelector('.quiz-email-input').value;

            if (!name || !email) {
                this.submitCardWrapper.classList.add('required');
                setTimeout(() => {
                    this.submitCardWrapper.classList.remove('required');
                }, 2000);
                return;
            }

            const emailPattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
            const verifiedEmail = email.match(emailPattern);

            if (verifiedEmail) {
                this.renderThankYou();

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'dad_report_result_signup',
                    property:'caregiver'
                });

                let formData = new FormData(this.signupForm);
                formData.append(
                    'existing_external_id',
                    window.md5(email)
                );
                const response = await fetch("https://datahub.klarify.me/api/webhook/create_braze_profile", {
                    method: "POST",
                    body: formData,
                });
                const res = await response.json();
                if (response.status == 200) {
                    if (res.data.attributes[0].external_id != '') {
                        if (typeof braze !== 'undefined') {
                            //braze sdk is loaded and we can tun the changeUser function
                            braze.changeUser(this.responseText);
                        }
                        if (typeof appboy !== 'undefined') {
                            //braze legacy sdk(appboy) is loaded and we can tun the changeUser function
                            appboy.changeUser(this.responseText);
                        }
                        if (!this.cookieHelper.getCookie('BUID_Cookie')) {
                            this.cookieHelper.setCookie('BUID_Cookie', res.data.attributes[0].external_id);
                        }
                        this.cookieHelper.setCookie('DADID_Cookie', res.data.attributes[0].external_id);
                        this.cookieHelper.setCookie('DAD_email', email);
                        this.DADID_Cookie = res.data.attributes[0].external_id;
                        this.DAD_email = email;


                        if (this.newsletterSignupCheckbox.checked) {
                            this.newsletterSignupVal = 'on';
                            localStorage.setItem('newsletter_signup', 'on');
                        } else {
                            this.newsletterSignupVal = 'off';
                            localStorage.setItem('newsletter_signup', 'off');
                        }

                        let bodyData = {
                            "response": this.answers,
                            "email": email,
                            "external_id": this.DADID_Cookie,
                            "language": this.signupForm.querySelector('input[name="language"]').value,
                        };
                        this.sendAnswer(bodyData);
                    }
                }
            }
        };
    }

    renderThankYou() {
        this.wrapper.classList.remove('active');
        this.wrapper.querySelector('.quiz-btn-description-wrapper').classList.remove('d-none');
        this.wrapper.querySelector('.anaphylaxis-heading').classList.remove('d-none');
        this.wrapper.querySelector('.quiz-close-btn').classList.add('d-none');
        this.startWrapper.classList.add('d-none');
        this.quizWrapper.classList.add('d-none');
        this.submitCardWrapper.classList.add('d-none');
        this.wrapper.classList.remove('active-dark-bg');
        this.wrapper.querySelector('.quiz-heading').classList.add('thanks-active');
        this.wrapper.querySelector('.quiz-heading').innerHTML = 'Thank you!';
        this.wrapper.querySelector('.quiz-btn-description-wrapper .quiz-description').innerHTML = 'Your child’s anaphylaxis discussion guide is on its way to your inbox. We hope it helps.';
    }

    resetQuiz() {
        this.currentQuestion = 0;
        this.answers = [];
        this.qaPairs = [];
        this.wrapper.classList.remove('active');
        this.wrapper.querySelector('.quiz-btn-description-wrapper').classList.remove('d-none');
        this.wrapper.querySelector('.anaphylaxis-heading').classList.remove('d-none');
        this.wrapper.querySelector('.quiz-close-btn').classList.add('d-none');
        this.startWrapper.classList.add('d-none');
        this.quizWrapper.classList.add('d-none');
        this.submitCardWrapper.classList.add('d-none');
        this.wrapper.classList.remove('active-dark-bg');
        this.consentCheckbox.checked = false;
    }

    async sendAnswer(bodyData) {
        try {
            const response = await fetch(`https://alk-app.klarify.me/api/child-digital-anaphylaxis-discussion-test`, {
                method: 'POST',
                headers: {
                    'Authorization': "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiMTRhMDYyZmI0NzcyYzQ5NTBhNzliZmQxMTFkZDZiYzEzNTEyMmIxZmE5NjYyNDI3Mzg4MDFhODVlYzM4MjllZDFlMDZhMThmY2EyODEyYWQiLCJpYXQiOjE3MDEwNjQyOTAuMTYyNTEyLCJuYmYiOjE3MDEwNjQyOTAuMTYyNTEzLCJleHAiOjIwMTY2ODM0OTAuMTU5Nzk2LCJzdWIiOiI3Iiwic2NvcGVzIjpbXX0.1b2KTcXzqbf7rxInHNqHluuwJ4VCZmiPhGpfDqRpqLVrppI_EpzHvvhKf-Aatrob-LzG509bc9bNKZ61fSaV_jotxi4_FAIE09h2RMNR6oKJaDFgN8slxLeVsmfOXfkegY0xQe93f_Ei2ms8s1_ISGwy4GG_VgttQMDFine9eI8q19qWM2sn3lMCP_DeyZDceGNw180M3eNCIEOLtvKEop8UKAFhaZ2WlO_yX8QiYtL6JIzC9pBUry2d_3wdE-ZqkckStczIVA8mqSdLWDmlaCytPz5V73ShU1NRI1BKKGoHjlTmcRL7IfELbcoF_lmKpPZSPk9WheP2G0G7M6qPgaWJYMLdZq5z54Ilt7K7WUGHhVkCrCl_e57HVDvRw9Fd1SNGVGSFolgowGsmAyJ-UXFco16a390FTtZy3myZd2EWS-iYkkKQ3CCqxcdg9XvjLKZi5yV1yBBerklxIUMZzzN__IoZYxELBdxQuD5EIjCrwBVshcPKRNDaQQUoAcPMNpzNp82roRPYu5sPFXIPTT3gPX5k8djNd536ES5-5Xs6mk42YiqTljb2rul9TOdq88_5QwlPRox664Tmt6w6iIU7wxKDFKucIhH9_ysGbpTIaSiPeDPhIxdxc4-INm1QBqTmx1X16zHhhLVK-ihLc1ad-6M4f5eWba0CbU0DXaE",
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(bodyData)
            });

            const res = await response.json();
            if (response.status == 200) {
                let dadResultId = res.dad_id;
                let externalId = this.DADID_Cookie;
                let externalEmail = this.DAD_email;

                const CurrDate = new Date();
                const polandTime = new Date(
                    CurrDate.toLocaleString("en-US", { timeZone: "Europe/Warsaw" })
                );
                const pad = (n) => n.toString().padStart(2, '0');
                const year = polandTime.getFullYear();
                const month = pad(polandTime.getMonth() + 1);
                const day = pad(polandTime.getDate());
                const hours = pad(polandTime.getHours());
                const minutes = pad(polandTime.getMinutes());
                const seconds = pad(polandTime.getSeconds());

                // Get Poland's UTC offset in minutes
                const offsetMinutes = -polandTime.getTimezoneOffset();
                const offsetSign = offsetMinutes >= 0 ? "+" : "-";
                const offsetHours = pad(Math.floor(Math.abs(offsetMinutes) / 60));
                const offsetMins = pad(Math.abs(offsetMinutes) % 60);

                // Format full date string
                const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${offsetSign}${offsetHours}:${offsetMins}`;

                const finalComment = this.answers.find(item => item.question_id === 'final_comment');
                if (finalComment) {
                    this.qaPairs.push({
                        question: 'My goals for the appointment',
                        answer: finalComment.comment
                    });
                }

                this.answers.forEach(item => {
                    switch (item.question_id) {
                        case 1:
                            if (item.answer === 'YES') {
                                this.qaPairs.push({
                                    question: 'Any changes in your child’s health since the last appointment?',
                                    answer: item.comment || item.answer
                                });
                            }
                            break;

                        case 2:
                            if (item.answer === 'YES') {
                                this.qaPairs.push({
                                    question: 'Any severe allergic reactions since the last appointment?',
                                    answer: item.comment || item.answer
                                });
                            }
                            break;

                        case 3:
                            if (item.answer === 'NO') {
                                this.qaPairs.push({
                                    question: 'Allergy triggers',
                                    answer: 'Ask the doctor how to identify my child’s allergy triggers'
                                });
                            }
                            break;

                        case 4:
                            if (item.answer === 'NO') {
                                this.qaPairs.push({
                                    question: 'How to avoid my child’s allergy triggers',
                                    answer: 'Ask the doctor how my child can avoid their allergy triggers'
                                });
                            }
                            break;

                        case 5:
                            if (item.answer === 'NO') {
                                this.qaPairs.push({
                                    question: 'Severe allergic reaction - what should we do?',
                                    answer: 'Ask the doctor to go through the steps of what to do'
                                });
                            }
                            break;

                        case 6:
                            if (item.answer === 'YES') {
                                this.qaPairs.push({
                                    question: 'Concerns about a severe allergic reaction',
                                    answer: item.comment || item.answer
                                });
                            }
                            break;

                        case 7:
                            if (item.answer === 'NO') {
                                this.qaPairs.push({
                                    question: 'How to use my child’s emergency medication',
                                    answer: 'Ask the doctor how and when to use my child’s emergency medication'
                                });
                            }
                            break;

                        case 8:
                            if (item.answer === 'YES') {
                                this.qaPairs.push({
                                    question: 'Other topics',
                                    answer: item.comment || item.answer
                                });
                            }
                            break;

                        case 9:
                            if (item.answer === 'YES') {
                                this.qaPairs.push({
                                    question: 'Questions about a new or existing allergy',
                                    answer: item.comment || item.answer
                                });
                            }
                            break;
                    }
                });


                let callEvents = [
                    {
                        "external_id": externalId,
                        "email": externalEmail,
                        "name": "anaphylaxis_quiz_completed_cgr",
                        "time": formattedDate,
                        "properties": {
                            "quiz_id": "anaphylaxis_child_discussion_guide",
                            "quiz_locale": this.signupForm.querySelector('input[name="language"]').value,
                            "quiz_source": "external_system",
                            "qa_count": this.qaPairs.length,
                            "qa_pairs": this.qaPairs,
                        }
                    }
                ];

                let bodyDataMap = {
                    "external_id": externalId,
                    "url_key": "dad_id",
                    "url_id": dadResultId,
                    "newsletter_signup": this.newsletterSignupVal,
                    "events": callEvents,
                };
                this.sendPDFtoBraze(bodyDataMap);

                console.log(bodyDataMap)

                this.resetQuiz();
            }

        } catch (e) {
            console.error('Filter API call failed', e);
        }
    }

    async sendPDFtoBraze(bodyDataMap) {
        try {
            const response = await fetch(`https://datahub-v2.klarify.me/api/general/pdf-url`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${window.datahubAPIKey}`,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(bodyDataMap)
            })
            if (response.status === 200) {
                await response.json();
            }
        } catch (e) {
            console.error('Filter API call failed', e);
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new AnaphylaxisQuiz();
});